module.exports = __webpack_public_path__ + "img/car.63118ab2.png";